export const FeatureToggleConstants = {
    InformationSection: false,
    EditIntakeHeader: false,
    HighlightGeneration: false,
    SearchTechnologyThroughCases: false,
    TechnologyCopying: false,
    SynonymGroups: false
} as const;